export default __webpack_public_path__ + "static/media/logo.5b8c8754.png";